import { Menu } from 'antd'
import { useIntl } from 'react-intl'

import { HelpSubMenu } from './HelpSubMenu'
import { NotificationsMenu } from './NotificationsSubMenu'
import { UserSubMenu } from './UserSubMenu'
import { FreeTrialButtonMenuItem } from '@/components/common/buttons/FreeTrialButton/FreeTrialButton'
import { MenuItem } from '@/components/ui/common/MenuItem'
import { useWorkspaceContext } from '@/context/WorkspaceContext'
import { useLoggedUser } from '@/hooks/useLoggedUser'
import { buildI18nFunction } from '@/utils/messages'

import styles from './HeaderMenu.module.css'

export function HeaderMenu(): JSX.Element {
  const { data: user } = useLoggedUser()
  const { workspaceId, workspace, membership } = useWorkspaceContext()
  const t = buildI18nFunction(useIntl().formatMessage)

  const menuItems: MenuItem[] = [
    {
      className: styles['notification-menu'],
      ...NotificationsMenu(workspaceId),
    },
    {
      className: styles['help-menu'],
      ...HelpSubMenu(t),
    },
    {
      className: styles['profile-menu'],
      ...UserSubMenu(user, t),
    },
  ]

  if (
    membership?.role === 'ADMIN' &&
    workspace?.descriptor?.trial === 'AVAILABLE' &&
    workspace?.on_boarding_status !== 'PENDING' &&
    workspace?.status === 'FREEMIUM'
  ) {
    menuItems.splice(0, 0, FreeTrialButtonMenuItem())
  }

  return (
    <Menu
      className={styles['header-menu']}
      rootClassName={styles['header-menu-popup']}
      mode="horizontal"
      selectable={false}
      items={menuItems}
    />
  )
}
